const routes = {
  root: '/company-notice/details',
}

export default routes
